﻿  // Cards Campaign – focinhos após inscrição; ao escolher mostra oferta (20% OFF, cupom, imagem, CTA)
document.addEventListener('DOMContentLoaded', function() {
  const FLIP_DURATION_MS = 1200;

function applyNoseSelection(selectedNose) {
  const noses = document.querySelectorAll('.nose');
  const panel = document.getElementById('cardsRewardPanel');
  const headerTitle = document.getElementById('cardsHeaderTitle');

  function revealReward() {
    
    window.scrollTo({top: 0, behavior: 'smooth'});

    if (panel) panel.classList.remove('hidden');

    if (headerTitle) {
      const rewardText = headerTitle.getAttribute('data-reward-text');
      if (rewardText) {
        headerTitle.textContent = rewardText;
      }
    }
  }

  noses.forEach(function(n) {
    if (n !== selectedNose) {
      n.classList.add('disabled');
    }
  });

  selectedNose.classList.add('sniff');

  setTimeout(function() {
    selectedNose.classList.remove('sniff');
    selectedNose.classList.add('flipped');
    revealReward();
  }, FLIP_DURATION_MS);
}

  function initCopyCoupon() {
    const btn = document.getElementById('copyCouponBtn');
    if (!btn) return;
    const coupon = btn.getAttribute('data-coupon') || '';
    const textEl = document.getElementById('copyCouponText');

    btn.addEventListener('click', function() {
      if (!coupon) return;
      function done() {
        if (textEl) textEl.textContent = 'Copiado!';
        btn.classList.add('copied');
        setTimeout(function() {
          if (textEl) textEl.textContent = 'Copiar cupom';
          btn.classList.remove('copied');
        }, 2000);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(coupon).then(done).catch(function() {
          fallbackCopy(coupon, done);
        });
      } else {
        fallbackCopy(coupon, done);
      }
    });
  }

  function fallbackCopy(code, onSuccess) {
    var ta = document.createElement('textarea');
    ta.value = code;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try {
      if (document.execCommand('copy')) onSuccess();
    } catch (e) {}
    document.body.removeChild(ta);
  }

  function initNoses() {
    const noses = document.querySelectorAll('.nose');
    noses.forEach(function(nose) {
      if (nose.dataset.initialized === 'true') return;
      nose.dataset.initialized = 'true';

      nose.addEventListener('click', function() {
        if (this.classList.contains('disabled') || this.classList.contains('flipped')) return;
        applyNoseSelection(this);
      });
    });
  }

  function init() {
    initCopyCoupon();
    initNoses();
  }

  function startCardsGame() {

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    var quiz = document.getElementById('cardsQuizForm');
    var game = document.getElementById('cardsGame');
    if (quiz) quiz.classList.add('hidden');
    if (game) {
      game.classList.remove('hidden');
      init();
    }
  }

  if (window.cardsFormSuccess) startCardsGame();

  var obs = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      if (m.type === 'attributes' && m.attributeName === 'class') {
        var game = document.getElementById('cardsGame');
        if (game && !game.classList.contains('hidden')) {
          init();
          obs.disconnect();
        }
      }
    });
  });
  var gameEl = document.getElementById('cardsGame');
  if (gameEl) {
    if (!gameEl.classList.contains('hidden')) init();
    else obs.observe(gameEl, { attributes: true });
  }
});
